import { render, staticRenderFns } from "./CardTarjaAudioEDCA.vue?vue&type=template&id=19d1fc42&scoped=true"
import script from "./CardTarjaAudioEDCA.vue?vue&type=script&lang=js"
export * from "./CardTarjaAudioEDCA.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaAudioEDCA.vue?vue&type=style&index=0&id=19d1fc42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d1fc42",
  null
  
)

export default component.exports